















































import {
  BankCustodian,
} from "@/admin/types";
import { Validator } from "vee-validate";
import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useAvidiaPartnerStore } from "@/admin/store/avidiaPartner";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class AvidiaBranchAndCostCenterSection extends Vue {
  @Prop() partnerId: number;
  @Prop() custodian: BankCustodian;
  $validator: Validator;

  costCenterId = 0;
  branchId = 0;
  isSaving = false;

  notifierStore = useNotifierStore();
  avidiaPartnerStore = useAvidiaPartnerStore();

  mounted () {
    this.onPartnerIdChange();
    this.onPartnerBranchAndCostCenterLoaded();
  }

  get canManage () {
    return this.avidiaPartnerStore.canManageBranchAndCostCenter(this.custodian);
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    if (this.avidiaPartnerStore.canManageBranchAndCostCenter) {
      this.avidiaPartnerStore.getPartnerBranchAndCostCenter(this.partnerId);
    }
  }

  @Watch("isLoading")
  onPartnerBranchAndCostCenterLoaded () {
    if (!this.isLoading) {
      this.costCenterId = this.currentAvidiaPartner.costCenterId;
      this.branchId = this.currentAvidiaPartner.branchId;
    }
  }

  get isLoading () {
    return this.avidiaPartnerStore.isLoadingPartnerBranchAndCostCenter(this.partnerId);
  }

  get currentAvidiaPartner () {
    return this.avidiaPartnerStore.partnerBranchAndCostCenter(this.partnerId);
  }

  onSave () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }
          this.isSaving = true;
          this.avidiaPartnerStore.beginSetPartnerBranchAndCostCenter({
            partnerId: this.partnerId,
            costCenterId: this.costCenterId,
            branchId: this.branchId
          }).then(result => {
            this.notifierStore.setSuccess("Cost Center and Branch have been saved");
            this.isSaving = false;
          }).catch(err => {
            if (err && err.message) {
              this.notifierStore.setDanger(err.message);
            } else {
              this.notifierStore.setDanger("Cost Center and Branch were not saved");
            }
            this.isSaving = false;
          });
        });
  }
}
